import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Inject,
} from "@angular/core";

import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";

import { LiveStreamDeprecated } from "@hermes/api-model-editorial";
import { Context } from "@hermes/app-core";
import { ExternalLibraryFacade } from "@hermes/states/external-library";

import { CHAPTERS_PARAGRAPH, IS_FIRST_PARAGRAPH } from "../../core";

enum StreamCasterType {
    FREECASTER = "freecaster",
    LETSEE = "letsee",
}

const LETSEE_BASE_URL = "https://bh-player.letsee.tv/embed/";

@Component({
    selector: "h-livestream",
    templateUrl: "./livestream.component.html",
    styleUrls: ["./livestream.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LivestreamComponent {
    public iframeUrl!: SafeResourceUrl;
    public readonly streamCasterType = StreamCasterType;

    constructor(
        @Inject(CHAPTERS_PARAGRAPH) public livestream: LiveStreamDeprecated,
        @Inject(IS_FIRST_PARAGRAPH) public isFirstParagraph: boolean,
        private context: Context,
        private changeDetectorRef: ChangeDetectorRef,
        private externalLibraryFacade: ExternalLibraryFacade,
        private sanitizer: DomSanitizer,
    ) {
        if (livestream.casterType === StreamCasterType.FREECASTER) {
            this.loadFreecasterV2();
        } else if (livestream.casterType === StreamCasterType.LETSEE) {
            this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
                `${LETSEE_BASE_URL}${livestream.videoId}`,
            );
        }

        if (!this.context.isInBrowserMode()) {
            this.changeDetectorRef.detach();
        }
    }

    public loadFreecasterV2(): void {
        const key = "FREECASTER";
        const windowAttribute = "fcplayer";
        const url =
            "https://player-v12.freecaster.com/freecaster/stable/fcplayer.js";
        this.externalLibraryFacade.load({ key, windowAttribute, url });
    }
}
